import React, { useEffect, useState } from 'react';
import HomePage from './pages/HomePage';
import FAQPage from './pages/FAQPage';
import NotFoundPage from './pages/NotFoundPage';
import { FAQ_PATH, matchRoute } from './routes';
import { Toaster } from './toaster';
import './index.css';

function App() {
  const [path, setPath] = useState(
    typeof window !== 'undefined' ? window.location.pathname : '/'
  );

  useEffect(() => {
    const updatePath = () => setPath(window.location.pathname);
    window.addEventListener('popstate', updatePath);
    window.addEventListener('app:navigate', updatePath as EventListener);
    return () => {
      window.removeEventListener('popstate', updatePath);
      window.removeEventListener('app:navigate', updatePath as EventListener);
    };
  }, []);

  useEffect(() => {
    if (window.location.pathname.replace(/\/+$/, '') === '/faqs.html') {
      window.history.replaceState({}, '', FAQ_PATH);
      setPath(FAQ_PATH);
    }
  }, []);

  const route = matchRoute(path);

  return (
    <>
      <Toaster />
      {route === 'faq' ? <FAQPage /> : route === 'home' ? <HomePage /> : <NotFoundPage />}
    </>
  );
}

export default App;
